import actions from './constants';

const applyWebsocket = (websocket) => ({ type: actions.APPLY_WEBSOCKET, websocket });

export default applyWebsocket;
